/**
 * @generated SignedSource<<5a5f5275acd724e2a05c53fdaccfd8a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptVideo_videoPlaybackSettings$data = {
  readonly id: string;
  readonly muted: boolean;
  readonly playbackRate: number;
  readonly subtitlesEnabled: boolean;
  readonly volume: number;
  readonly " $fragmentType": "TranscriptVideo_videoPlaybackSettings";
};
export type TranscriptVideo_videoPlaybackSettings$key = {
  readonly " $data"?: TranscriptVideo_videoPlaybackSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptVideo_videoPlaybackSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "playbackRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitlesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "volume",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muted",
      "storageKey": null
    }
  ],
  "type": "UserVideoPlaybackSettings",
  "abstractKey": null
};

(node as any).hash = "1c928ba19efd3ee485c31406c54ff689";

export default node;
